// extracted by mini-css-extract-plugin
export default {"root":"_2v6Qu","large":"_3fGUp","hoverable":"_1FKA1","medium":"_3A3nY","small":"_1wbjv"};